import { Injectable } from "@angular/core";
import { ArticleInfos } from "../../models/article.model";

export type DlcStatus = "ok" | "warning" | "expired";

export interface DlcResult {
  status: DlcStatus;
  label: string | null;
  remainingDays: number | null;
}

@Injectable({ providedIn: "root" })
export class ArticleInfosHelperService {
  static uniteDenomination(articleInfos: ArticleInfos) {
    if (!articleInfos) {
      return "";
    }
    return articleInfos.unite?.denomination ?? "";
  }

  static computeDlc(
    dluo: string | Date | null | undefined,
    articleInfos: ArticleInfos | null | undefined,
  ): DlcResult {
    if (!dluo) return { status: "ok", label: null, remainingDays: null };

    const dluoDate = new Date(dluo);
    dluoDate.setHours(0, 0, 0, 0);
    const now = new Date();
    now.setHours(0, 0, 0, 0);

    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    if (dluoDate <= yesterday) {
      return { status: "expired", label: null, remainingDays: 0 };
    }

    if (!articleInfos) return { status: "ok", label: null, remainingDays: null };

    const totalDays =
      (articleInfos.dluoJours ?? 0) +
      (articleInfos.dluoMois ?? 0) * 30 +
      (articleInfos.dluoAnnes ?? 0) * 365;

    if (totalDays <= 0)
      return { status: "ok", label: null, remainingDays: null };

    const remainingDays = Math.round(
      (dluoDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24),
    );
    const warningThreshold = Math.ceil(totalDays * 0.2);

    if (remainingDays <= warningThreshold) {
      return { status: "warning", label: `${remainingDays}j`, remainingDays };
    }

    return { status: "ok", label: null, remainingDays };
  }

  static isDluoExpired(dluo: string | Date | null | undefined): boolean {
    if (!dluo) return false;
    const dluoDate = new Date(dluo);
    dluoDate.setHours(0, 0, 0, 0);
    const yesterday = new Date();
    yesterday.setHours(0, 0, 0, 0);
    yesterday.setDate(yesterday.getDate() - 1);
    return dluoDate <= yesterday;
  }
}
